export default {
  header_text_0: {
    ua: 'Підтримати проєкт',
    en: 'Support the project',
  },
  header_text_1: {
    ua: 'c.Збини 29, Мукачівській р-н, Закарпатська обл.',
    en: 'Zbyny 29, Mukachevo district, Transcarpathian region.',
  },
  header_text_2: {
    ua: 'Про нас',
    en: 'About us',
  },
  header_text_3: {
    ua: 'Проєкти',
    en: 'Projects',
  },
  header_text_4: {
    ua: 'Контакти',
    en: 'Contacts',
  },
  header_text_5: {
    ua: 'Співпраця',
    en: 'Collaboration',
  },
  header_nav_menu_1: {
    ua: 'c.Збини 29, Мукачівській р-н, Закарпатська обл.',
    en: 'Zbyny 29, Mukachevo district, Transcarpathian region.',
  },
  header_nav_menu_2: {
    ua: 'Про нас',
    en: 'About us',
  },
  header_nav_menu_3: {
    ua: 'Проєкти',
    en: 'Projects',
  },
  header_nav_menu_4: {
    ua: 'Контакти',
    en: 'Contacts',
  },
  header_nav_menu_5: {
    ua: 'Співпраця',
    en: 'Collaboration',
  },
  contribution_1: {
    ua: 'Запрошуємо до співпраці',
    en: 'We invite you to cooperate',
  },
  contribution_2: {
    ua: 'Волонтери',
    en: 'Volunteers',
  },
  contribution_3: {
    ua: 'Якщо Ви відчуваєте потребу поділитися своїми знаннями, навичками і талантами - запрошуємо до команди! Разом ми зробимо більше.',
    en: 'If you feel the need to share your knowledge, skills and talents, we invite you to join our team! Together we will do more.',
  },
  contribution_4: {
    ua: 'Дізнатись більше',
    en: 'Learn more',
  },
  contribution_5: {
    ua: 'Ментори',
    en: 'Mentors',
  },
  contribution_6: {
    ua: 'Ви можете записати надихаюче відео для сільських дітей або приїхати і зустрітися з людьми, які будуть вдячні почути Вас і надихнутися Вашим досвідом та досягненнями!',
    en: 'You can record an inspirational video for rural children or come and meet people who will be grateful to hear from you and inspired by your experience and achievements!',
  },
  contribution_7: {
    ua: 'Дізнатись більше',
    en: 'Learn more',
  },
  contribution_8: {
    ua: 'Партнери',
    en: 'Partners',
  },
  contribution_9: {
    ua: 'Станьте партнерами ГО ЗЕРНО і долучіться до розвитку щасливих сільських громад! Ви можете долучитися своїм досвідом,товаром, якій виробляєте, або ж матеріальною підтримкою актуальних проєктів!',
    en: 'Become a partner of ZERNO and contribute to the development of happy rural communities! You can contribute with your experience, products, or material support for current projects!',
  },
  contribution_10: {
    ua: 'Дізнатись більше',
    en: 'Learn more',
  },
  mentors_1: {
    ua: 'Що може входити в обов’язки ментора',
    en: "What may be included in the mentor's responsibilities",
  },
  mentors_2: {
    ua: 'Проводити семінари',
    en: 'Conduct seminars',
  },
  mentors_3: {
    ua: 'Давати наставництво',
    en: 'Provide mentoring',
  },
  mentors_4: {
    ua: 'Розвивати лідерські навички учасників',
    en: 'Develop leadership skills of participants',
  },
  mentors_5: {
    ua: 'Вирішення підліткових питань',
    en: 'Solving teenage issues',
  },
  mentors_6: {
    ua: 'Надавати корисні матеріали',
    en: 'Provide useful materials',
  },
  mentors_7: {
    ua: 'Консультувати',
    en: 'Consult',
  },
  mentors_8: {
    ua: 'Ментор',
    en: 'Mentor',
  },
  mentors_9: {
    ua: '- це досвідчена людина, яка надає підтримку, поради та наставництво менш досвідченим людям, зазвичай в межах професійного або особистісного розвитку. Ментор допомагає розвивати навички, вдосконалювати знання та досягати поставлених цілей. Нам дуже потрібні експерти в різних сферах для розвитку молоді, дітей та жінок.',
    en: '- is an experienced person who provides support, advice, and mentoring to less experienced people, usually as part of a professional or personal development development. A mentor helps to develop skills, improve knowledge, and achieve goals. We really need experts in various fields for the development of youth, children and women.',
  },
  mentors_10: {
    ua: 'Закрити',
    en: 'Close',
  },
  partners_1: {
    ua: 'Що може входити в обов’язки партнера',
    en: "What may be the partner's responsibilities",
  },
  partners_2: {
    ua: 'Фінансова підтримка',
    en: 'Financial support',
  },
  partners_3: {
    ua: 'Матеріальна підтримка',
    en: 'Material support',
  },
  partners_4: {
    ua: 'Підтримка загального добробуту',
    en: 'Supporting the general welfare',
  },
  partners_5: {
    ua: 'Підтримка культурного розвитку',
    en: 'Support for cultural development',
  },
  partners_6: {
    ua: 'Облаштування приміщення',
    en: 'Room arrangement',
  },
  partners_7: {
    ua: 'Фінансування поточних витрат',
    en: 'Financing of current expenses',
  },
  partners_8: {
    ua: 'Партнери',
    en: 'Partners',
  },
  partners_9: {
    ua: "- це спонсори та меценати або організація які надають фінансову чи матеріальну підтримку для реалізації проектів подій чи діяльності спільноти. Партнери надають фінансову підтримку в обмін на рекламу чи інші вигоди, що пов'язані з подією чи проєктом або без прямої вигоди вкладають внесок у розвиток організації.",
    en: '- are sponsors and patrons or organizations that provide financial or or material support for the realization of events or community activities. community projects. Partners provide financial support in exchange for advertising or other benefits related to the event or project or without direct benefit contribute to the development of the organization.',
  },
  partners_10: {
    ua: 'Закрити',
    en: 'Close',
  },
  volonteer_1: {
    ua: 'Що може входити у обов’язки волонтера',
    en: "What can be included in the volunteer's duties",
  },
  volonteer_2: {
    ua: 'Створення контенту',
    en: 'Content creation',
  },
  volonteer_3: {
    ua: 'Вести соцмережі',
    en: 'Maintain social networks',
  },
  volonteer_4: {
    ua: 'Організаційні питання',
    en: 'Organizational issues',
  },
  volonteer_5: {
    ua: 'Робота руками',
    en: 'Work with your hands',
  },
  volonteer_6: {
    ua: 'Комунікація з учасниками',
    en: 'Communication with participants',
  },
  volonteer_7: {
    ua: 'Листування',
    en: 'Correspondence',
  },
  volonteer_8: {
    ua: 'Волонтер',
    en: 'Volunteer',
  },
  volonteer_9: {
    ua: '- це добровільна участь у роботі або прoєкті на безоплатній основі з метою допомогти та підтримки спільноти та її ідеї. Якщо ви хочете стати волонтером та у вас є ідеї для співпраці, то негайно заповнюйте форму для співпраці, а наш менеджер протягом дня вам зателефонує. Ми цінуємо ваше бажання долучитися до нашого проєкту та раді вислухати будь-які пропозиції.',
    en: '- is voluntary participation in a work or project on a pro bono basis to help and support the community and its ideas. If you want to become a a volunteer and you have ideas for cooperation, then immediately fill out the for cooperation, and our manager will contact you within a day. We appreciate your desire to join our project and are happy to listen to any suggestions.',
  },
  volonteer_10: {
    ua: 'Закрити',
    en: 'Close',
  },
  activity_0: {
    ua: 'Що ми робимо',
    en: 'What we do',
  },
  activity_1: {
    ua: 'Фільтр',
    en: 'Filter',
  },
  activity_2: {
    ua: 'Усі',
    en: 'All',
  },
  activity_3: {
    ua: 'Для дітей',
    en: 'For kids',
  },
  activity_4: {
    ua: 'Для жінок',
    en: 'For women',
  },
  activity_5: {
    ua: 'Мистецтво',
    en: 'Art',
  },
  activity_6: {
    ua: 'Дозвілля',
    en: 'Leisure',
  },
  activity_7: {
    ua: 'Екологія та довкілля',
    en: 'Ecology and environment',
  },
  activity_8: {
    ua: 'для жінок',
    en: 'for women',
  },
  activity_9: {
    ua: "Ми граємось, стоїмо на голові, в планці, на одній нозі, чи кидаємо один одному м'яч, називаючи тварину, або рослину английськю, Ми змагаємось за найбільшу кількість вивчених англійськіх слів, оскільки переможець місяця отримає приз! Ми придумуємо сценки, імпровізуємо і дивимось мультики англійською! Це найкраща англиійстка в світі і наші діти щоразу щасливіші, бо впевнені!",
    en: 'We play by standing on our heads, in a plank, on one leg, or throwing a ball a ball to each other, naming an animal or a plant in English, We are competing for the most English words learned, because the winner of the month gets a prize! We make up skits, improvise and watch cartoons in English! This is the best English teacher in the world and our children are happier every time because they are confident!',
  },
  activity_10: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  activity_11: {
    ua: 'Йога для дітей та дорослих',
    en: 'Yoga for children and adults',
  },
  activity_12: {
    ua: 'для дітей',
    en: 'for kids',
  },
  activity_13: {
    ua: 'для жінок',
    en: 'for women',
  },
  activity_14: {
    ua: "Займаємось йогою для початківців, яка допомагає зняти стрес, зменшити рівень тривожності у дитей та жінок, робить тіло гнучкішим та здоровішим. Рівна постава - запорука здоров'я та ознака успішної людини!",
    en: 'We do yoga for beginners, which helps relieve stress, reduce anxiety in children and women, and make the body more flexible and healthy. Straight posture is the key to health and a sign of a successful person!',
  },
  activity_15: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  activity_16: {
    ua: 'М/К “Вибійка”',
    en: 'M/s “Vybijka”',
  },
  activity_17: {
    ua: 'для дітей',
    en: 'for kids',
  },
  activity_18: {
    ua: 'Давня техніка декорування текстилю шляхом перенесення відбитку з різьбленої дошки. Дsти створюють власний орнамент на одязі та домашньому текстилі. Розвиваємо креативне мислення та впринтовуємо в підсвідомість позитивні символи природи та традиційні орнаменти.',
    en: 'An ancient technique of decorating textiles by transferring a print from a from a carved board. Children create their own ornaments on clothes and home textiles. We develop creative thinking and imprint positive symbols of nature positive symbols of nature and traditional ornaments into the subconscious.',
  },
  activity_19: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  activity_20: {
    ua: 'М/К “Виготовлення мотанки”',
    en: 'M/C “Production of motanka”',
  },
  activity_21: {
    ua: 'для дітей',
    en: 'for kids',
  },
  activity_22: {
    ua: 'для дорослих',
    en: 'for adults',
  },
  activity_23: {
    ua: 'Прекрасний сімейний майстер-клас, куди можна прийти трьома поколіннями та створити свої обереги. Крутити мотанки під силу всім. Прекрасні ляльки сповнені тепла Ваших рук, заряджені Вашими думками, стануть незамінним оберегом Вашої оселі. Ми використовуємо лише натуральні матеріали, дотримуємося автентичної технології, не використовуємо гострих предметів. Приходьте та відчуйте дух українського автентичного мистецтва виготовлення ляльки-мотанки. Виготовлення мотанки - чудовий майстер-клас для дорослих і дітей.',
    en: 'A great family workshop where three generations can come and create their own amulets. Everyone is able to spin the rope for everyone. Beautiful dolls full of the warmth of your hands, charged with your thoughts will become an indispensable amulet for your home. We use only natural materials, adhere to authentic technology, and do not use sharp objects. Come and feel the spirit of the Ukrainian authentic art of making motanka dolls. Making motanka is a great workshop for for adults and children.',
  },
  activity_24: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  activity_25: {
    ua: 'М/К “Ебру”',
    en: 'M/S “Ebru”',
  },
  activity_26: {
    ua: 'для дітей',
    en: 'for kids',
  },
  activity_27: {
    ua: 'Ебру - живопис на воді, для якого не потрібно бути художником, бо це інтуїтивний живопис - це чари на воді, де ви спробуєте сотворити свій шедевр і потім цю картину перевести на папір або на сумку, на одежу. Неймовірні емоціі, які перенесуть вас до казки',
    en: 'Ebru is a painting on water, for which you do not need to be an artist, because it is an intuitive painting - it is magic on the water, where you will try to to create your own masterpiece and then transfer this painting to paper or to a bag, on clothes. Incredible emotions that will take you to a fairy tale',
  },
  activity_28: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  activity_29: {
    ua: 'М/К “Писанкарство”',
    en: 'M/C “Pysankarstvo”',
  },
  activity_30: {
    ua: 'для дітей',
    en: 'for kids',
  },
  activity_31: {
    ua: 'Давня традиція розписувати яйця воском, яка майже втрачена на селах, оскількі простіше вікорістовувати наклейкі. Але ми відроджуємо це містичне дійство, яке символізує саме народження життя!',
    en: 'The ancient tradition of waxing eggs has almost been lost in the countryside, as it is easier to use stickers. But we are reviving this mystical act, which symbolizes the very birth of of life itself!',
  },
  activity_32: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  activity_33: {
    ua: 'М/К “Мандали”',
    en: 'M/C “Mandali”',
  },
  activity_34: {
    ua: 'для жінок',
    en: 'for women',
  },
  activity_35: {
    ua: 'Ми будемо не просто створювати Мандали, а закладати в неї особливі емоції, особливий настрій, хорошу енергетику, свої бажання, те, що ви хочете реалізувати в своєму житті. Цей майстер-клас допоможе визначити життєві орієнтири для щасливого плавання по відкритому океану життя. На майстер-класі буде практика планування ваших цілей та мрій та творче перетворення їх реальність. На учасників чекає практика глибокого відпочинку та оновлення сил в атмосфері тепла, краси та творчості.',
    en: 'We will not just create Mandalas, but put special emotions, a special mood, good energy, your desires, what you want to realize in your life. you want to realize in your life. This workshop will help you to to determine life guidelines for happy sailing on the open ocean of life. ocean of life. The master class will include the practice of planning your goals and dreams and creatively transforming them into reality. The participants will will practice deep relaxation and renewal in an atmosphere of of warmth, beauty and creativity.',
  },
  activity_36: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  activity_37: {
    ua: 'М/К “Свічки з віску і трави Карпат”',
    en: 'M/C “Candles made of wax and herbs of the Carpathians”',
  },
  activity_38: {
    ua: 'для жінок',
    en: 'for women',
  },
  activity_39: {
    ua: 'мистецтво',
    en: 'art',
  },
  activity_40: {
    ua: 'екологія та довкілля',
    en: 'ecology and environment',
  },
  activity_41: {
    ua: 'На Майстер-класі ми вчимося робити свічки. Гості заходу дізнаються тонкощі наповнення свічок травами і маслами, особливості скручування, запалювання і енергетичної роботи. Свічки ручної роботи виготовляються з натурального воску, який стає податливим від тепла Ваших рук і формується в красиву і елегантну свічку. Робити свічки своїми руками - це неймовірне задоволення, а свічка із воску стане чудовою прикрасою Вашої оселі. Декорування свічки своїми руками дозволяє проявити максимум фантазії. Простота  створення свічок своїми руками робить цей майстер-клас доступним для всіх. Медові свічки своїми руками - це чудове заняття для своєрідної медитації. Запах меду піднімає настрій і заспокоює нерви. Користь свічок з вощини очевидна, оскільки всі матеріали екологічно чисті.',
    en: 'At the workshop, we will learn how to make candles. Guests of the event will learn the intricacies of filling candles with herbs and oils, the peculiarities of of twisting, lighting and energy work. Handmade candles handmade candles are made of natural wax, which becomes pliable from the warmth of your hands and is formed into a beautiful and elegant candle. Making candles with your own hands is an incredible pleasure, and a candle candle will be a wonderful decoration for your home. Decorating a candle with your own hands allows you to show maximum imagination. Simplicity  of making candles with your own hands makes this master class accessible for everyone. Do-it-yourself honey candles are a great activity for a kind of meditation. The smell of honey lifts your mood and calms your and calms the nerves. The benefits of wax candles are obvious, as all the materials are are environmentally friendly.',
  },
  activity_42: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  activity_43: {
    ua: 'М/К “Миловаріння”',
    en: 'M/C “Soap-making”',
  },
  activity_44: {
    ua: 'для жінок',
    en: 'for women',
  },
  activity_45: {
    ua: 'дозвілля',
    en: 'leisure',
  },
  activity_46: {
    ua: 'Миловаріння – не тільки цікаве та медитативне заняття, а ще й дуже корисне. Ми поділимося з вами секретами створення мила, покажемо варіанти роботи з формою та кольорами. Звісно, розкажемо вам про тонкощі створення мила у формі квітів та з додаванням сухих квітів. Кожен учасникам матиме змогу створити власноруч власний кусочок мила і забрати його з собою додому.',
    en: 'Soap making is not only an interesting and meditative activity, but also very useful. We will share with you the secrets of soap making and show you options for working with shapes and colors. Of course, we will tell you about the intricacies of creating soap in the shape of flowers and with the addition of dried flowers. Each participant will have the opportunity to create their own a bar of soap and take it home with them.',
  },
  activity_47: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  activity_48: {
    ua: 'Дискусійний клуб',
    en: 'Discussion club',
  },
  activity_49: {
    ua: 'для жінок',
    en: 'for women',
  },
  activity_50: {
    ua: 'дозвілля',
    en: 'leisure',
  },
  activity_51: {
    ua: 'Тут ми обговорюємо поняття Мрий, Цілей, Відповідальності, Лідерства, Вибору та інші. Переглядаємо пізнавальні фільми на проекторі (з попкорном, звісно:) та надихаючі відео, записані видатними людьми спеціально для нас!',
    en: 'Here we discuss the concepts of Dreams, Goals, Responsibility, Leadership, Choice, and others. We watch educational movies on the projector (with popcorn, of course:) and inspirational videos recorded by by famous people especially for us!',
  },
  activity_52: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  activity_53: {
    ua: 'М/К “Мокре валяння”',
    en: 'M/C “Wet felting”',
  },
  activity_54: {
    ua: 'для жінок',
    en: 'for women',
  },
  activity_55: {
    ua: 'мистецтво',
    en: 'art',
  },
  activity_56: {
    ua: 'Мокре валяння – це техніка, за допомогою якої ви зможете створювати різноманітні декоративні елементи, предмети одягу, різноманітні аксесуари. Для мокрого валяння використовують мильний розчин, який розкриває лусочки на волокнах вовни, а потім механічними рухами їм допомагають зчепитися один з одним. На майстер-класі ви навчитеся працювати з вовною, основами мокрого валяння, правильно підбирати фурнітуру. Своїми руками зробіть елемент декору або прикраси для вашого одягу.',
    en: 'Wet felting is a technique that allows you to create a variety of decorative elements, clothing items, and various accessories. For wet felting, a soapy solution that opens the scales on the wool fibers, and then mechanical movements help them to adhere to each other. At the the workshop you will learn how to work with wool, the basics of wet felting felting, and how to choose the right accessories. You will make with your own hands a decorative element or decoration for your clothes.',
  },
  activity_57: {
    ua: 'За подробицями завітай у наш',
    en: 'For more details, visit our',
  },
  contacts_1: {
    ua: 'Як нас знайти',
    en: 'How to find us',
  },
  contacts_2: {
    ua: 'Контактні дані',
    en: 'Contact details',
  },
  contacts_3: {
    ua: 'Село Збини 29, Мукачівській район, Закарпатська область',
    en: 'Zbyny 29 village, Mukachevo district, Zakarpattia region',
  },
  donatBtn_1: {
    ua: 'Підтримати проєкт',
    en: 'Support the project',
  },
  faq_0: {
    ua: 'Запитання й відповіді',
    en: 'Questions and answers',
  },
  faq_1: {
    ua: 'Кому підходять заходи ?',
    en: 'For whom are the events suitable?',
  },
  //!  тимчасовий текст
  faq_2: {
    ua: 'ЗЕРНО - місце для кожного, хто бажає зробити світ кращим через творчість.',
    en: 'Join our charity events and do good by expressing yourself creatively.',
  },
  //!  тимчасовий текст
  faq_3: {
    ua: 'ЗЕРНО - місце для кожного, хто бажає зробити світ кращим через творчість.',
    en: 'Join our charity events and do good by expressing yourself creatively.',
  },
  faq_4: {
    ua: 'Як можна забронювати місце на захід ?',
    en: 'How can I book a place at the event ?',
  },
  faq_5: {
    ua: 'Оберіть в розділі “Події” захід, який вам найбільш сподобався, ознайомтесь з його описом, тисніть на кнопку “Забронювати”. В формі, яка з’явится заповніть необхідні поля. Зверніть увагу, що у формі можна вказати не більше 3-х учасників.',
    en: 'Select the event you like the most in the Events section, read its description, and click the "Book" button. In the form fill in the required fields. Please note that in the form you can specify no more than 3 participants.',
  },
  faq_6: {
    ua: 'Ваші заходи платні ?',
    en: 'Are your events paid ?',
  },
  //!  тимчасовий текст
  faq_7: {
    ua: 'Всі наші заходи абсолютно безкоштовні, завдяки неоціненному внеску волонтерів та наполегливій роботі команди ЗЕРНО.',
    en: 'All our events are completely free of charge, thanks to the invaluable contribution of volunteers and the hard work of the ZERNO team.',
  },
  //!  тимчасовий текст
  faq_8: {
    ua: 'Разом ми творимо позитивні зміни, роблячи це доступним для кожного!',
    en: 'Together we create positive change by making it accessible to everyone!',
  },
  faq_9: {
    ua: 'Чи є фудкорт ?',
    en: 'Is there a food court?',
  },
  //!   тимчасовий текст
  faq_10: {
    ua: 'Звісно!',
    en: 'Answer.',
  },
  //!   тимчасовий текст
  faq_11: {
    ua: 'Організація ЗЕРНО робить все можливе, щоб надати неперевершені заходи з атмосферою та кулінарними насолодами. Наший фудкорт - це місце, де ви зможете насолоджуватися унікальними стравами від талановитих кухарів. І найкраще в цьому - все абсолютно безкоштовно, завдяки великодушності та підтримці наших небайдужих партнерів та команди ЗЕРНО!',
    en: 'The ZERNO organization does its best to provide unrivaled events with atmosphere and culinary delights. Our food court is a place where you can enjoy unique dishes from talented chefs. And the best part is that everything is absolutely free, thanks to the generosity and support of our caring partners and the ZERNO team!',
  },
  faq_12: {
    ua: 'Якщо не знайшли відповідь на запитання ?',
    en: 'If you did not find the answer to the question ?',
  },
  faq_13: {
    ua: 'Відповідь на будь-які поточні питання можна задати нам у',
    en: 'For any current questions, please contact us at',
  },
  faq_14: {
    ua: 'каналі',
    en: 'channel',
  },
  faq_15: {
    ua: 'Яка мета існування організації “Зерно”?',
    en: 'What is the purpose of the Zerno organization?',
  },
  //!   тимчасовий текст
  faq_16: {
    ua: 'Організація "Зерно" існує з метою створення позитивних змін у суспільстві через впровадження волонтерської та благодійної діяльності.',
    en: 'The Zerno organization exists to create positive changes in society through the implementation of volunteer and charitable activities.',
  },
  //!   тимчасовий текст
  faq_17: {
    ua: "Наша мета - надихати, підтримувати та об'єднувати людей для спільної творчості та розвитку громадськості. Ми віримо, що кожна дія може стати зерном добра, яке проросте у силу позитивних змін у нашому світі.",
    en: 'Our goal is to inspire, support and unite people for joint creativity and community development. We believe that every action can become a seed of goodness that will germinate into positive changes in our world.',
  },
  footer_1: {
    ua: 'Про нас',
    en: 'About us',
  },
  footer_2: {
    ua: 'Проєкти',
    en: 'Projects',
  },
  footer_3: {
    ua: 'Контакти',
    en: 'Contacts',
  },
  footer_4: {
    ua: 'Співпраця',
    en: 'Cooperation',
  },
  footer_5: {
    ua: 'Про нас',
    en: 'About us',
  },
  footer_6: {
    ua: 'Проєкти',
    en: 'Projects',
  },
  footer_7: {
    ua: 'Контакти',
    en: 'Contacts',
  },
  footer_8: {
    ua: 'Співпраця',
    en: 'Cooperation',
  },
  footer_9: {
    ua: 'Про нас',
    en: 'About us',
  },
  footer_10: {
    ua: 'Проєкти',
    en: 'Projects',
  },
  footer_11: {
    ua: 'Контакти',
    en: 'Contacts',
  },
  footer_12: {
    ua: 'Співпраця',
    en: 'Cooperation',
  },
  footer_13: {
    ua: 'Звітність',
    en: 'Reporting',
  },
  footer_14: {
    ua: 'Політика конфіденційності',
    en: 'Privacy policy',
  },
  footer_15: {
    ua: 'Правила користування сайтом',
    en: 'Terms of use of the site',
  },
  footer_16: {
    ua: 'Розробка Baza Trainee Ukraine 2023 (©) Усі права захищені',
    en: 'Developed by Baza Trainee Ukraine 2023 (©) All rights reserved',
  },
  founder_1: {
    ua: 'Пані Христина - засновниця організації',
    en: 'Ms. Khrystyna is the founder of the organization',
  },
  founder_2: {
    ua: 'Христина Патик - засновниця ГО "Зерно", віддана і творча особистість, яка вкладає всю енергію та любов в проєкт. Її візія і завзята робота роблять наш світ кращим, а кожен крок призводить до позитивних змін.',
    en: 'Khrystyna Patyk is the founder of Zerno, a dedicated and creative person who puts all her energy and love into the project. Her vision and hard work make our world a better place, and every step she takes leads to positive change.',
  },
  gallery_1: {
    ua: 'Галерея',
    en: 'Gallery',
  },
  hero_1: {
    ua: 'відчуй',
    en: 'feel',
  },
  hero_2: {
    ua: 'твори',
    en: 'works',
  },
  hero_3: {
    ua: 'надихай',
    en: 'inspire',
  },
  hero_4: {
    ua: 'ГО Зерно визначає критерії щасливого життя, навчає жити щасливо',
    en: 'NGO Zerno defines criteria for a happy life, teaches how to live happily',
  },
  missions_1: {
    ua: 'Місія',
    en: 'Mission',
  },
  missions_2: {
    ua: 'Наша місія - працювати задля підвищення рівня щастя в сільських громадах.',
    en: 'Our mission is to work to increase the level of happiness in rural communities.',
  },
  missions_3: {
    ua: 'Слоган: вміти бути щасливим!',
    en: 'Slogan: Know how to be happy!',
  },
  missions_4: {
    ua: 'Ведемо велику просвітницьку роботу серед дітей та підлітків - майстер-класи, дискусійні клуби, організовуємо дозвілля для сільських дітей та ВПО.',
    en: 'We do a lot of educational work among children and teenagers workshops, discussion clubs, and organize leisure activities for rural children and IDPs.',
  },
  missions_5: {
    ua: 'Цілі',
    en: 'Goals',
  },
  missions_6: {
    ua: 'Збереження традицій, виховання Еко свідомої молоді, мотивація на навички щасливих та успішних людей, розвиток жіночого підприємництва та жіночого дозвілля на селі.',
    en: "Preservation of traditions, education of eco-conscious youth, motivation for skills happy and successful people, development of women's entrepreneurship and women's leisure in rural areas.",
  },
  missions_7: {
    ua: 'Задачі',
    en: 'Objectives',
  },
  missions_8: {
    ua: 'Організувати постійно діючі творчі та спортивні гуртки для сільської молоді.',
    en: 'Organize permanent creative and sports clubs for rural youth.',
  },
  missions_9: {
    ua: 'Cтворити безпечний, творчий, розвиваючий простір для сільських жінок.',
    en: 'To create a safe, creative, and developing space for rural women.',
  },
  missions_10: {
    ua: 'Oрганізувати рекреаційні табори для дітей, що постраждали від війни.',
    en: 'Organize recreational camps for children affected by the war.',
  },
  modal_1: {
    ua: 'Оберіть суму пожертви для ГО Зерно',
    en: 'Please select the amount of your donation for NGO Zerno',
  },
  modal_2: {
    ua: 'Одноразово',
    en: 'One-time',
  },
  modal_3: {
    ua: 'Щотижня',
    en: 'Weekly',
  },
  modal_4: {
    ua: 'Щомісячно',
    en: 'Monthly',
  },
  modal_5: {
    ua: 'або введіть суму',
    en: 'or enter an amount',
  },
  modal_6: {
    ua: 'Підтримати проєкт',
    en: 'Support the project',
  },
  modal_7: {
    ua: 'Введіть суму',
    en: 'Enter the amount',
  },
  partners_0: {
    ua: 'Наші партнери',
    en: 'Our partners',
  },
  // social_1: {
  //   ua: 'Як це виглядає',
  //   en: 'What it looks like',
  // },
  subscription_1: {
    ua: 'Бажаєш приєднатись до команди ?',
    en: 'Want to join the team ?',
  },
  subscription_2: {
    ua: 'Хочу підтримати',
    en: 'I want to support',
  },
  subscription_3: {
    ua: 'Підтримати проєкт',
    en: 'Support the project',
  },
  subscription_4: {
    ua: 'Хочу допомогти',
    en: 'I want to help',
  },
  subscription_5: {
    ua: 'Заповнити форму',
    en: 'Fill out the form',
  },
  team_1: {
    ua: 'Команда',
    en: 'Team',
  },
  team_2: {
    ua: 'Анастасія-Марія Романків',
    en: 'Anastasia-Maria Romankiv',
  },
  team_3: {
    ua: 'Аня Сомова',
    en: 'Anya Somova',
  },
  team_4: {
    ua: 'Андрій Перегінець',
    en: 'Andriy Perehinets',
  },
  team_5: {
    ua: 'Віктор Пилипчук',
    en: 'Viktor Pylypchuk',
  },
  team_6: {
    ua: 'Дмитро Попович',
    en: 'Dmytro Popovych',
  },
  team_7: {
    ua: 'Дмитро Русаков',
    en: 'Dmitry Rusakov',
  },
  directions_1: {
    ua: 'Заняття з дітьми',
    en: 'Classes with children',
  },
  directions_2: {
    ua: 'Природа та довкілля',
    en: 'Nature and environment',
  },
  directions_3: {
    ua: 'Уроки англійської',
    en: 'English lessons',
  },
  directions_4: {
    ua: 'Мистецтво і рукоділля',
    en: 'Arts and crafts',
  },
  directions_5: {
    ua: 'Підтримка громад',
    en: 'Supporting communities',
  },
  map_1: {
    ua: 'Село Збини 29.',
    en: 'Zbyny village 29.',
  },
  map_2: {
    ua: 'Мукачівський район.',
    en: 'Mukachevo district.',
  },
  map_3: {
    ua: 'Закарпатська обл.',
    en: 'Zakarpattia obl.',
  },
  map_4: {
    ua: 'Україна.',
    en: 'Ukraine.',
  },
  modalThanks_1: {
    ua: 'Ваш донат отримано, дякуємо за підтримку',
    en: 'Your donation has been received, thank you for your support',
  },
};
